import { LearnMoreTooltip } from "@features/sales-v3/top-level-filters/components/learn-more-tooltip";
import {
  NBAccountingMode,
  type INBAccountingMode,
} from "@north-beam/nb-common";
import { Select } from "@shared/selects";
import { type ExtendableSelectProps } from "@shared/selects/select";

interface NbAccountingModeSelectProps extends ExtendableSelectProps {
  className?: string;
  isLoading: boolean;
  nbAccountingMode: INBAccountingMode | null;
  onChange: (obj: any) => void;
  accrualOnly?: boolean;
}

export const NbAccountingModeSelect = ({
  label = "ACCOUNTING MODE",
  className,
  isLoading,
  nbAccountingMode,
  onChange,
  accrualOnly,
  ...props
}: NbAccountingModeSelectProps) => {
  const value = nbAccountingMode
    ? NBAccountingMode.toReactSelect(nbAccountingMode)
    : { value: null, label: "" };

  const labelTooltip = (
    <LearnMoreTooltip
      title="Accounting Mode"
      content="Northbeam's accounting models determine the amount of revenue and transactional credit given on a particular day"
      link="https://docs.northbeam.io/docs/accounting-modes"
    />
  );

  const labelWithTooltip = label && (
    <>
      {label} {labelTooltip}
    </>
  );

  return (
    <Select
      label={labelWithTooltip}
      className={className}
      isLoading={isLoading}
      value={value.value}
      icon={<i className="fa-regular fa-sharp fa-calculator" />}
      options={
        accrualOnly
          ? [{ value: "accrual", label: "Accrual Performance" }]
          : NBAccountingMode.reactSelectOptions
      }
      onChange={onChange}
      {...props}
    />
  );
};
